// bookmark or tag question, hint
<template>
  <v-container class="mx-auto">
    <v-text centered> Question {{ counter }} of {{ questions.length }} </v-text>
    <question :question="questions[counter - 1]" />

    <v-container class="m-10">
      <v-btn
        v-if="counter > 1"
        class="float-left ml-10 navBtn"
        rounded
        color="primary"
        dark
        v-on:click="counter -= 1"
        >Back to Last Question</v-btn
      >
      <v-btn
        v-if="counter < questions.length"
        rounded
        class="float-right mr-10 navBtn"
        color="primary"
        dark
        v-on:click="counter += 1"
        >Save and Continue</v-btn
      >
      <v-btn
        v-if="counter == questions.length"
        rounded
        class="float-right mr-10 navBtn"
        color="warning"
        dark
        >Submit Test</v-btn
      >
    </v-container>
    <div class="text-center">
      <v-pagination
        v-model="counter"
        :length="questions.length"
        circle
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import Question from "@/components/prep/Question.vue";

export default {
  data: function() {
    return {
      counter: 1,
      search: "",
      questions: [
        {
          number: 1,
          score: 5,
          type: "cr",
          question: "What is 1 + 1 - 1?",
          answer: "2",
          knowledgePoints: ["addition", "subtraction"],
          pValue: 99,
          averageTime: 3,
          hint: " add then substract",
          marked: false,
        },
        {
          number: 2,
          type: "cr",
          score: 5,
          question: "What is 10 x 15?",
          answer: "1500",
          knowledgePoints: ["multiplicaton"],
          pValue: 60,
          averageTime: 3,
          hint: "move zero from 10",
          marked: false,
        },
        {
          number: 3,
          type: "mc",
          score: 5,
          question: "Who is the first president of United States?",
          choices: [
            "Donald Trump",
            "Zedong Mao",
            "George Washington",
            "Barack Obama",
          ],
          answer: "George Washington",
          knowledgePoints: ["American History I"],
          pValue: 80,
          averageTime: 1,
          hint: "The oldest one",
          marked: false,
        },
      ],
    };
  },
  components: {
    question: Question,
  },
  methods: {},
};
</script>

<style scoped>
.navBtn {
  z-index: 20;
  position: relative;
  top: 40px;
}
</style>
